const scene = "subject/";

export const UPDATE_SUBJECT = `${scene}UPDATE_SUBJECT`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;
export const UPDATE_SUBJECT_ELECTIVE = `${scene}UPDATE_SUBJECT_ELECTIVE`;

